module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_f_albino.2545768e.png";